import React, { useEffect, useState } from "react";
import BlogItem from "../BlogList/BlogItem";
import BreadCrumb from "../BreadCrumb";
import Sidebar from "../BlogList/Sidebar";
import Pagination from "../ProductCategory/Pagination";
import { useRouter } from "next/router";
import { GetBlog } from "../api";
import { useTranslation } from "../../context/TranslationContext";

const BlogList = ({ ssr, isAppWebView }) => {
  const { blogPage } = useTranslation();
  const router = useRouter();
  const [data, setData] = useState(ssr.result.BlogData.result);
  const [totalPage, setTotalPage] = useState(ssr.result.BlogData.TotalPage);
  const [currentPage, setCurrentPage] = useState(
    ssr.result.BlogData.CurrentPage,
  );

  const setPage = (page) => {
    GetBlog(page, "").then((e) => {
      setData(e.data.BlogData.result);
      setTotalPage(e.data.BlogData.TotalPage);
      setCurrentPage(page);

      router.replace({
        query: { slug: [e.data.url, page] },
      });
    });
  };

  const SearchOnSubmit = (SearchText) => {
    const { query } = router;
    query.slug = [blogPage.url];

    if (SearchText) {
      query.search = SearchText;
    } else {
      delete query.search;
    }
    router.replace(
      {
        query: query,
      },
      undefined,
      {
        scroll: true,
        shallow: true,
      },
    );
    GetBlog(1, SearchText).then((e) => {
      setData(e.data.BlogData.result);
      setTotalPage(e.data.BlogData.TotalPage);
      setCurrentPage(1);
      router.replace({
        query: { slug: [e.data.url], search: SearchText },
      });
    });
  };

  return (
    <>
      <BreadCrumb data={ssr.result.BreadCrumb} isAppWebView={isAppWebView} />
      <div className="blog-list">
        <div className="container">
          <div className="grid grid-cols-12 gap-x-8">
            <div className="lg:col-span-8 col-span-12">
              {data.map((e, i) => (
                <BlogItem data={e} key={i} />
              ))}
              <div className="mb-10">
                <Pagination
                  totalPage={totalPage}
                  currentPage={currentPage}
                  setPage={setPage}
                />
              </div>
            </div>
            <Sidebar
              SearchOnSubmit={SearchOnSubmit}
              LastShared={ssr.result.BlogData.LastShared}
              Popular={ssr.result.BlogData.Popular}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogList;
